import { Component, OnInit, Inject } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { TasksAndGroupsService } from 'src/app/Services/TaskAndGroup/tasks-and-groups.service';
import { Router } from '@angular/router';
import { CommonComponents } from 'src/app/Sharedservice/CommonComponents';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AcceptRejectUsers, IMessagesTasksInbox, ITaskReply } from 'src/app/models/IMessagesTasksInbox';
import { MessagesReplayForwardComponent } from '../messages-replay-forward/messages-replay-forward.component';
import { ToastrService } from 'ngx-toastr';
import { stat } from 'fs';
import { PatientBannerService } from 'src/app/patient-banner/patient-banner.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { SharedService } from 'src/app/Sharedservice/SharedService';


@Component({
  selector: 'app-taskmessagesview',
  templateUrl: './taskmessagesview.component.html',
  styleUrls: ['./taskmessagesview.component.css']
})
export class TaskmessagesviewComponent implements OnInit {

  taskMessagesViewForm: FormGroup;
  taskId: number = 0;
  ViewMessages: IMessagesTasksInbox[] = [];
  ReplyForwardMessagesList: IMessagesTasksInbox[] = [];
  taskRowObj: IMessagesTasksInbox;
  acceptedBy: string;
  logComments: string;
  disableReject: boolean = false;
  disableAccept: boolean = false;
  disableComplete: boolean = false;
  disableForward: boolean = false;
  disableReply: boolean = false;
  disableCommentsLog: boolean = false;
  msgbtnType: string = '';
  IsSideNav: boolean = false;
  commentText: string = "";
  hideButtons: boolean = true;
  hideButtons1: boolean = true;
  constructor(public dialog: MatDialog, private formBuilder: FormBuilder, private _taskandgroupservice: TasksAndGroupsService, private router: Router
    , public dialogRef: MatDialogRef<any>
    , @Inject(MAT_DIALOG_DATA) public data: any, private toastr: ToastrService
    , private bannerService: PatientBannerService, private spinner: NgxSpinnerService
    , private dateservice: SharedService) {
    this.taskId = this.data.Id;
    this.taskRowObj = this.data.ele;
    this.msgbtnType = this.data.btnType;
    this.IsSideNav = this.data.IsSideNav;
    if (this.msgbtnType == 'MessageTracker') {
      this.hideButtons1 = false;
    } else {

    }
    this.getLocationDate();
  }

  ngOnInit() {

    this.taskMessagesViewForm = this.formBuilder.group({
      notes: [''],
      replyNotes: ['']
    });
    this.taskId = this.data.Id;
    this.GetAcceptAndRejectStatus(this.taskId);
    //this.getMessageInfoByTaskId();
    this.clickOn_log();
    this.getTaskNotes();
    this.getMessageReplyNotes();
    this.getReplyMessages();
  }
  locationDate: string = "";
  getLocationDate() {
    this.dateservice.getservercurrentdate().subscribe(async result => {
      await result;
      this.locationDate = result;

    });
  }
  allMessagesInbox: IMessagesTasksInbox;
  getMessageInfoByTaskId() {
    // this.spinner.show();
    //  alert(this.checkInboxSend)
    this._taskandgroupservice.GetInboxMessageByTaskId(this.taskId).subscribe(data => {
      this.allMessagesInbox = data
      if (this.allMessagesInbox != undefined && this.allMessagesInbox != null) {
        //this.PatientName
        // if (this.allMessagesInbox.IsFroward == true) {
        //  // if (this.allMessagesInbox.IsFroward == true && this.allMessagesInbox.Status == 4) {
        //     // this.hideButtons = false;
        //     // this.disableForward = true;
        //     // this.disableReply = true;
        //     // this.disableCommentsLog = true;
        // //  } else {
        //     if (this.allMessagesInbox.Status == 4) {
        //       this.hideButtons = false;
        //     } 
        //     // else {
        //     //   this.disableAccept = true;
        //     //   this.disableReject = true;
        //     //   this.disableComplete = true;
        //     //   this.disableForward = true;
        //     //   this.disableReply = true;
        //     //   this.disableCommentsLog = true;
        //     // }
        //  // }

        //   // if (this.allMessagesInbox.IsFroward == true && this.msgbtnType == "Sent") {
        //     if (this.msgbtnType == "Sent") {
        //     // this.disableForward = true;
        //     // this.disableReply = true;
        //     // this.disableCommentsLog = true;
        //     this.hideButtons = false;
        //   }
        // }
        if (this.allMessagesInbox.Status == 4) {
          this.hideButtons = false;
        }
        if (this.msgbtnType == "Sent") {
          if (this.allMessagesInbox.Status == 3) {
            this.disableAllBtns()
          } else {
            this.hideButtons = false;
          }

        }
        //else {

        if (this.msgbtnType == "Sent") {
          this.hideButtons = false;
        } else {
          if (this.allMessagesInbox.Status == 4) {
            this.hideButtons = false;
          } else if (this.allMessagesInbox.Status == 3) {
            this.disableAllBtns()
          } else {
            if (this.acceptandRejectStatusList.length > 0) {

              this.disableReject = this.isRejectbtnEnabled();
              if (this.disableReject) {
                this.disableComplete = this.disableReject;
                this.disableAccept = this.disableReject;
              }
              else {
                this.disableComplete = !this.iscompletebtnEnabled();
                this.disableAccept = this.disableComplete ? !this.isAcceptbtnEnabled() : true;
              }
            }

          }
        }
        // }

        if (this.allMessagesInbox.PatientName != "" && this.allMessagesInbox.PatientName != undefined && this.allMessagesInbox.PatientName != null) {
          this.ViewMessages.forEach(element => {
            element.PatientName = this.allMessagesInbox.PatientName;
          });
        }

      }

      //   this.spinner.hide();
    },
      (err: any) => {
        console.log(err)
        //this.spinner.hide();
      });
  }
  getReplyMessages() {
    this._taskandgroupservice.GetForwardReplyByTaskId(this.taskId).subscribe(data => {
      this.ReplyForwardMessagesList = data
      if (this.ReplyForwardMessagesList.length != 0) {
        this.ReplyForwardMessagesList.forEach(y => {
          this.ViewMessages.forEach(element => {
            element.PatientName = y.PatientName;
          });
        })
        this.ReplyForwardMessagesList.forEach(x => {
          if (x.DueDate == '0001-01-01T00:00:00') {
            x.DueDate = "";
          }
        })
      }



    },
      (err: any) => {
        console.log(err)
      });
  }
  _msgtask: IMessagesTasksInbox;
  _msgtaskReply: ITaskReply;
  showBox: boolean = false;
  showReply: boolean = false;
  showlogInfo: boolean = false;
  showNotesInfo: boolean = true;
  checkRejectAccept: string = "";
  comments: boolean = true;
  replay: boolean = false;
  AddNote(type: string) {
    this.checkReplyClick = false;
    this.taskMessagesViewForm.patchValue({
      notes: '',
    })
    this.checkRejectAccept = '';
    this.replay = false;
    this.comments = true;
    if (type == 'Reject') {
      this.commentText = 'Reject Comments:'
      this.checkRejectAccept = 'Reject';
    } else if (type == 'Accept') {
      this.commentText = 'Accept Comments:'
      this.checkRejectAccept = "Accept";
    } else if (type == 'Complete') {
      this.commentText = 'Completed Comments:'
      this.checkRejectAccept = "Complete";
    } else if (type == 'Add') {
      //this.checkRejectAccept = "";
      this.commentText = 'Comments:'
    }
    else {
      this.checkRejectAccept = "";
    }
    this.showBox = true;
    this.showlogInfo = false;
    //this.showReply=false;
    //this.showNotesInfo =!this.showNotesInfo;;
  }
  checkReplyClick: boolean = false;
  onReplay_Click() {
    this.commentText = 'Reply Comments:'
    this.taskMessagesViewForm.patchValue({
      notes: '',
    })
    this.checkReplyClick = true;
    this.replay = true;
    this.comments = false;
    this.showBox = true;
    this.showReply = true;

    // this._msgtaskReply = new ITaskReply();
    // let loginUser = sessionStorage.getItem("userId");
    // this._msgtaskReply.FromUserId = loginUser// this.ViewMessages[0].FrmUserId;
    // this._msgtaskReply.ReplyedTo = this.ViewMessages[0].FrmUserId;
    // this._msgtaskReply.TaskId = this.messageTaskMasterId;
    // this._msgtaskReply.CreatedBy = loginUser;
    // this._msgtaskReply.CreatedOn = this.locationDate;
    // this._msgtaskReply.Note = this.taskMessagesViewForm.value.notes;

    if (this.IsSideNav) {
      this.dialogRef.close();
    }
    this.showBox = false;
    const dialogRef = this.dialog.open(MessagesReplayForwardComponent, {
      width: '90%', height: '90%',
      data: { taskObj: this.ViewMessages, type: 'R' },
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result != undefined) {
        this.getMessagesViewById(this.taskId);
        this.getMessageInfoByTaskId();
        this.getReplyMessages();
      }
    });
  }
  _Cancel() {
    this.showBox = false;
  }
  onNotes_Save() {
    if (this.checkReplyClick == true) {
      if (this.taskMessagesViewForm.value.notes == "") {
        this.toastr.error('Please enter reply notes')
        return false;
      }
      this._msgtaskReply.Note = this.taskMessagesViewForm.value.notes;
      this._msgtaskReply.FacilityId = Number(sessionStorage.getItem("FacilityId"));
      this._msgtaskReply.CreatedOn = this.locationDate;
      this.spinner.show();
      this._taskandgroupservice.SaveReplyNotes(this._msgtaskReply).subscribe(data => {
        this.toastr.success('Message Reply successfully.')
        this.showBox = false;
        this.checkRejectAccept = "";
        this.getMessageReplyNotes();
        this.taskMessagesViewForm.patchValue({
          notes: '',
        })
        this.spinner.hide();
      },
        (err: any) => {
          console.log(err)
          this.spinner.hide();
        });
    } else {
      this._msgtask = new IMessagesTasksInbox();
      var checkNotes = this.taskMessagesViewForm.value.notes;
      var loginUser = sessionStorage.getItem("userId");
      this._msgtask.FromUserId = loginUser;
      this._msgtask.MessageTaskMasterId = this.messageTaskMasterId;
      this._msgtask.CreatedBy = loginUser;
      this._msgtask.Note = this.taskMessagesViewForm.value.notes;
      this._msgtask.CreatedOn = this.locationDate;
      this._msgtask.FacilityId = Number(sessionStorage.getItem("FacilityId"));
      if (this.checkRejectAccept == 'Reject') {
        if (checkNotes == "" || checkNotes == undefined || checkNotes == null) {
          this.toastr.error('Please enter reason for reject comments')
          return false;
        } else {
          this._msgtask.RejectedBy = loginUser;
          this._msgtask.AcceptedBy = "";
          this._msgtask.RequestType = 'Reject';
          this._msgtask.CompleeteedBy = "";
        }

      } else if (this.checkRejectAccept == "Complete") {
        // if (checkNotes == "" || checkNotes == undefined || checkNotes == null) {
        //   this.toastr.error('Please enter complete comments')
        //   return false;
        // } else {
        this._msgtask.RejectedBy = "";
        this._msgtask.AcceptedBy = "";
        this._msgtask.CompleeteedBy = loginUser;
        this._msgtask.RequestType = 'Complete';
        // }
      }
      else if (this.checkRejectAccept == "Accept") {
        // if (checkNotes == "" || checkNotes == undefined || checkNotes == null) {
        //   this.toastr.error('Please enter Accept comments')
        //   return false;
        // } else {
        this._msgtask.RejectedBy = "";
        this._msgtask.AcceptedBy = loginUser;
        this._msgtask.CompleeteedBy = "";
        this._msgtask.RequestType = 'Accept';
        //}
      }
      else {
        if (checkNotes == "" || checkNotes == undefined || checkNotes == null) {
          this.toastr.error('Please enter comments before Save.')
          return false;
        }
        this._msgtask.RejectedBy = "";
        this._msgtask.AcceptedBy = "";
        this._msgtask.CompleeteedBy = "";
        this._msgtask.RequestType = "";
      }
      this.spinner.show();
      this._taskandgroupservice.SaveTasksNotes(this._msgtask).subscribe(data => {
        this.toastr.success(data)
        this.spinner.hide();
        this.GetAcceptAndRejectStatus(this.taskId);
        this.getMessagesViewById(this.taskId);
        this.taskMessagesViewForm.patchValue({
          notes: '',
        })
        this.getTaskNotes();
        this.showBox = false;
        this._msgtask.RejectedBy = "";
        this._msgtask.AcceptedBy = "";
        this._msgtask.CompleeteedBy = "";
      },
        (err: any) => {
          console.log(err)
          this.spinner.hide();
        });
    }

  }
  replyList: ITaskReply[];
  getMessageReplyNotes() {
    ;
    this._taskandgroupservice.getReplyNotes(this.taskId).subscribe((results: any) => {
      this.replyList = results;
      this.getMessageInfoByTaskId();
      if (this.replyList.length != 0) {
        this.showReply = true;
      } else {
        // this.showReply = false;
      }

    })
  }
  messageTaskMasterId: number = 0;

  iscompletebtnEnabled() {

    let statusList = this.acceptandRejectStatusList.some(x =>
      x.MailUserIds === sessionStorage.getItem("userId") && x.IsAccept == 'A' && x.IsReject == null)
    return statusList;
  }


  isAcceptbtnEnabled() {
    // alert('fired');
    let statusList = !this.acceptandRejectStatusList.some(x =>
      (x.IsAccept == 'A' && x.IsReject == null))

    if (!statusList) {
      statusList = this.acceptandRejectStatusList.some(x =>
        (x.MailUserIds === sessionStorage.getItem("userId") && x.IsAccept == 'A' && x.IsReject == 'R'))
    }

    // if (!statusList) {
    //   statusList = this.acceptandRejectStatusList.some(x =>
    //     (sessionStorage.getItem("userId") && x.IsAccept == 'A' && x.IsReject == null))
    // }
    return statusList;
  }
  isRejectbtnEnabled() {
    let statusList = this.acceptandRejectStatusList.some(x =>
      x.MailUserIds === sessionStorage.getItem("userId") && (x.IsReject == 'R'))
    return statusList;
  }
  disableAllBtns() {
    this.disableAccept = true;
    this.disableReject = true;
    this.disableComplete = true;
    this.disableForward = true;
    this.disableReply = true;
    this.disableCommentsLog = true;
  }
  getMessagesViewById(Id) {
    this._taskandgroupservice.getMessagesViewById(Id).subscribe((results: any) => {
      this.ViewMessages = results;
      this.messageTaskMasterId = this.ViewMessages[0].MessageTaskMasterId;
      this.getMessageInfoByTaskId()
      if (results[0].DueDate.split('-')[0] == '0001') {
        results[0].DueDate = '';
        this.ViewMessages = results;
      }
    });
  }
  onAcceptTaskClick() {
    var loggedUser = sessionStorage.getItem("username");
    this.acceptedBy = 'Accepted by ' + loggedUser;
  }

  forwardfun() {
    const dialogRef = this.dialog.open(MessagesReplayForwardComponent, {
      width: '90%', height: '90%',
      data: { taskObj: this.ViewMessages, type: 'F' },
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result != undefined) {
        this.getMessageInfoByTaskId();
        this.getReplyMessages();
      }
    });
  }
  onForwardClick() {
    if (this.IsSideNav) {
      this.dialogRef.close();
    }
    this.showBox = false;
    const dialogRef = this.dialog.open(MessagesReplayForwardComponent, {
      width: '90%', height: '90%',
      data: { taskObj: this.ViewMessages, type: 'F' },
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result != undefined) {
        this.getMessageInfoByTaskId();
        this.getReplyMessages();
        this.getMessagesViewById(this.taskId);

      }
    });
  }
  NavigatetoDocuments() {
    sessionStorage.setItem("patientId", this.ViewMessages[0].PatientId.toString());
    sessionStorage.setItem("patientName", this.ViewMessages[0].PatientName);
    CommonComponents.patientId = this.ViewMessages[0].PatientId;
    CommonComponents.patientName = this.ViewMessages[0].PatientName;
    this.bannerService.toggle(CommonComponents.patientId);
    sessionStorage.removeItem("hideDocumentsHeader");
    this.router.navigateByUrl('/', { skipLocationChange: true }).then(() =>
      this.router.navigate(['/DocumentHome']));
    this.dialogRef.close();
  }
  //Get Messages and Task Notes
  _notesList: IMessagesTasksInbox[] = [];
  acceptedList: string[];
  getTaskNotes() {

    this._taskandgroupservice.getTaskMessagesNotes('', this.taskId).subscribe((results: any) => {
      this._notesList = results;
      if (this._notesList.length != 0) {
        this._notesList = this._notesList.filter(x => x.Note != "")
      }
      this.clickOn_log();
      if (this._notesList.length == 0) {
        //this.showNotesInfo=false;
      }
    })
  }
  labelRej: string = "";
  rejectedBy: string = "";
  labelAcpt: string = "";
  acceptedDate: Date;
  rejectedDate: Date;
  _noteslogList: IMessagesTasksInbox[] = [];
  clickOn_log() {
    ;
    this.showNotesInfo = !this.showNotesInfo;
    this.showlogInfo = !this.showlogInfo
    this.showBox = false;
    if (this.showlogInfo == false) {
      this.showNotesInfo = true;
    }
    this._taskandgroupservice.getTaskMessagesNotes('AcceptRejectedNotes', this.taskId).subscribe((results: any) => {
      this._noteslogList = results;
    })
  }
  CloseDailog() {
    this.dialogRef.close(false);
  }
  acceptandRejectStatusList: AcceptRejectUsers[] = []
  GetAcceptAndRejectStatus(Id: number) {
    this._taskandgroupservice.GetAcceptAndRejectUserList(Id).subscribe((ARResult: any) => {
      this.acceptandRejectStatusList = ARResult;
      //this.getMessageInfoByTaskId();
      this.getMessagesViewById(this.taskId);
    },
      error => {
        //this.getMessageInfoByTaskId();
        this.getMessagesViewById(this.taskId);
      });
  }
}
